var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTeam = function SvgTeam(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M7.584.007c-2.516 0-4.563 2.17-4.563 4.838s2.047 4.838 4.563 4.838c2.516 0 4.564-2.17 4.564-4.838S10.1.007 7.584.007zM17.959.7h-.031c-1.056.008-2.042.454-2.777 1.255-.722.787-1.115 1.825-1.106 2.922.009 1.098.419 2.13 1.154 2.904.74.781 1.722 1.21 2.766 1.21h.031c1.056-.009 2.043-.455 2.778-1.256.722-.786 1.114-1.824 1.105-2.922C21.86 2.538 20.105.699 17.96.699zM18.151 9.783h-.379c-1.764 0-3.375.671-4.59 1.77.304.234.593.488.868.763.81.81 1.445 1.753 1.89 2.804.4.946.628 1.943.682 2.97H25V16.63c0-3.776-3.072-6.848-6.849-6.848z",
    transform: "translate(-4 -6) translate(4 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M15.154 18.09c-.138-2.226-1.267-4.184-2.95-5.44-1.226-.912-2.746-1.453-4.392-1.453h-.456C3.293 11.197 0 14.491 0 18.554v.873h15.168v-.873c0-.156-.004-.31-.014-.464z",
    transform: "translate(-4 -6) translate(4 6)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/team.620eff3d.svg";
export { ForwardRef as ReactComponent };